import React, {
  useCallback,
  useState,
  useEffect
} from 'react';
import {
  Box,
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import useIsMountedRef from 'src/hooks/useIsMountedRef';
import Header from './Header';
import Filter from './Filter';
import Results from './Results';
import { THREAD_FETCH_START,THREAD_FETCH_SUCCESS,THREAD_FETCH_FAIL } from 'src/slices/ThreadSlice';

import { USER_THREADS_TIMELINE_API } from 'src/Api/Community/Index';
import { useDispatch, useSelector } from 'react-redux';
import { ENDPOINT, TIMER_MILISECONDS } from 'src/utils/helper';
import ThreadFilter from './ThreadFilter';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { io } from 'socket.io-client';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  headline:{
    textAlign: 'center',
    fontSize: "18px"
  },
  intro:{
    color: "#000",
    marginTop: "10px",
    textAlign:"center",
    marginBottom: "20px",
  }
}));

const ProjectBrowseView = () => {
  const dispatch=useDispatch();
  const classes = useStyles();
  const {authData}=useSelector((state)=>state.authData);
  const {threadData}=useSelector((state)=>state.threadData);
  const [threads, setThreads] = useState([]);
  const [page,setPage]=useState(1)
  const [limit,setLimit]=useState(9)
  const [pageCount,setPageCount]=useState(0)
  const [threadCount,setThreadCount]=useState(0)

  const [selectedSort, setSelectedSort] = useState('');
  const location = useLocation();
  
  const setSelectedTagUsingUrl=()=>{
    const queryParams = new URLSearchParams(location.search);
    // console.log(queryParams);
    const tagValue = queryParams.get('tag');
    // console.log('tagValue',tagValue);
    if(tagValue){
      setSelectedSort((prev)=>tagValue);
    }else{
      setSelectedSort('')
    }
  }

  useEffect(() => {    
    setSelectedTagUsingUrl();
    // getThreads();
  }, [location.search]);

  const getThreads = (async () => {
    try {
      // console.log('selectedSort',selectedSort);
      // console.log('page',page);
      dispatch(THREAD_FETCH_START());
      // console.log("selectedSort ====>>>",selectedSort);    
      const {data}=await USER_THREADS_TIMELINE_API(authData.com_userId,page,limit,selectedSort)
      // console.log(data);
      const {status,list,message,total,count}=data;
      if(status){
        setThreadCount(total);
        setPageCount(Math.ceil(total/limit))
        setThreads(list);
        dispatch(THREAD_FETCH_SUCCESS(list));
      }else{
        dispatch(THREAD_FETCH_FAIL(message));
      }
    } catch (err) {
      dispatch(THREAD_FETCH_FAIL(err));
      console.error(err);
    }
  });
  useEffect(() => {
    getThreads();
  }, [page,selectedSort]);

  // useEffect(() => {
  //   getThreads();
  // }, [dispatch]);

  useEffect(() => {
    setThreads(threadData) 
    // console.log('page effect outer ',page);
    const intervalId = setInterval(() => {
      // console.log('page effect',page);
      getThreads();
    }, TIMER_MILISECONDS); 
    return () => clearInterval(intervalId);
  }, [selectedSort,page]);
  
  return (
    <Page
      className={classes.root}
      title="Thread List"
    >
      <Container maxWidth="lg">
        <Box mt={1} mb={3}>
          <h1  className={classes.headline}>Welcome to Opus-Hub</h1>
          <p className={classes.intro}>Opus Hub functions as a community platform where students can pose questions to their peers and mentors, receiving responses in the form of replies. This setup promotes collaborative learning and facilitates the sharing of knowledge among participants.</p>
        </Box>
        <Header />
        <Box mt={3}>
          {/* <Filter /> */}
          <ThreadFilter selectedSort={selectedSort} setSelectedSort={setSelectedSort} />
        </Box>
        <Box mt={1}>
          <Results threads={threads} page={page} setPage={setPage} pageCount={pageCount} selectedSort={selectedSort} setSelectedSort={setSelectedSort} threadCount={threadCount} setThreadCount={setThreadCount} />
        </Box>
      </Container>
    </Page>
  );
}

export default ProjectBrowseView;
